import api from '../api';
import { AxiosError } from 'axios';
import { ParamsBodyValidatePersonalData, ParamsDataValidatePersonalData } from 'utils/typeServices';
interface ErrorResponse {
    Data: string;
}

export const PostValidatePersonalData = async ({ body, token }: ParamsBodyValidatePersonalData) => {
    const bodyJson = JSON.stringify(body);

    try {
        const { data } = await api.post<ParamsDataValidatePersonalData>('v1/Cliente/ValidarDadosPessoa', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        // const successSendCommunication = data.mensagem.some(m => m.ComunicacaoEnviada === true);

        return { data: data };
    } catch (error) {
        const axiosError = error as AxiosError<ErrorResponse>;

        return {
            data: null,
            specificError: axiosError?.response?.data?.Data.includes('Os dados informados (CNPJ/CPF ou Data de Nascimento) não correspondem à essa pessoa')
        };
    }
}
